// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ub-0";
export var checkoutRateBadgeLink = "_ub-1";